/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorFormSection } from './HchbPayorFormSection';
import {
    HchbPayorFormSectionFromJSON,
    HchbPayorFormSectionFromJSONTyped,
    HchbPayorFormSectionToJSON,
    HchbPayorFormSectionToJSONTyped,
} from './HchbPayorFormSection';

/**
 * 
 * @export
 * @interface HchbPayorFormDefinition
 */
export interface HchbPayorFormDefinition {
    /**
     * 
     */
    branch: string;
    /**
     * 
     */
    payor_type: string;
    /**
     * 
     */
    sections: Array<HchbPayorFormSection>;
}

/**
 * Check if a given object implements the HchbPayorFormDefinition interface.
 */
export function instanceOfHchbPayorFormDefinition(value: object): value is HchbPayorFormDefinition {
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('payor_type' in value) || value['payor_type'] === undefined) return false;
    if (!('sections' in value) || value['sections'] === undefined) return false;
    return true;
}

export function HchbPayorFormDefinitionFromJSON(json: any): HchbPayorFormDefinition {
    return HchbPayorFormDefinitionFromJSONTyped(json, false);
}

export function HchbPayorFormDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorFormDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'branch': json['branch'],
        'payor_type': json['payor_type'],
        'sections': ((json['sections'] as Array<any>).map(HchbPayorFormSectionFromJSON)),
    };
}

export function HchbPayorFormDefinitionToJSON(json: any): HchbPayorFormDefinition {
    return HchbPayorFormDefinitionToJSONTyped(json, false);
}

export function HchbPayorFormDefinitionToJSONTyped(value?: HchbPayorFormDefinition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branch': value['branch'],
        'payor_type': value['payor_type'],
        'sections': ((value['sections'] as Array<any>).map(HchbPayorFormSectionToJSON)),
    };
}

